import styled from 'styled-components';
import tw from 'tailwind.macro';

const Container = styled.div`
  ${tw`px-medium2 lg:px-0`}
  @media (min-width: 992px) {
    display: grid !important;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: var(--size-medium2);
    grid-row-gap: var(--size-medium2);
  }

  @media (min-width: 1440px) {
    padding: 0 116px;
  }
`;

const MainColumn = styled.div`
  @media (min-width: 992px) {
    grid-column-start: 3;
    grid-column-end: 8;
  }
`;

const AsideColumn = styled.div`
  ${tw`hidden 
    lg:block
    `}

  @media (min-width: 992px) {
    grid-column-start: 8;
    grid-column-end: 11;
  }
`;

const FullColumn = styled.div`
  @media (min-width: 992px) {
    grid-column-start: 3;
    grid-column-end: 11;
  }
`;

export { AsideColumn, Container, FullColumn, MainColumn };
